// The phase captions describe the existing footage, not a hardware specification.
export const productVideos = [
  {
    id: "tour-gpu",
    src: "/products/tour-gpu-exploded.mp4",
    poster: "/products/tour-carthy.webp",
    name: "Tour GPU CARTHY",
    videoTitle: "Présentation de la tour GPU CARTHY",
    storyId: "explorer-tour",
    eyebrow: "À l’intérieur de la tour",
    storyTitle: "La puissance GPU, vue de l’intérieur.",
    scrollHint: "Faites défiler pour explorer la tour, de l’ouverture à la fermeture.",
    manualTitle: "Découvrez la tour en mouvement.",
    description: "Une station au format tour qui réunit plusieurs cartes graphiques et les composants de calcul dans un châssis sur roulettes.",
    phases: [
      { start: 0, label: "Ouverture", title: "La tour s’ouvre.", text: "Les panneaux s’écartent pour dévoiler les composants et la structure du châssis." },
      { start: 3, label: "Intérieur", title: "La configuration se dévoile.", text: "La vue éclatée révèle les cartes graphiques et leur disposition à l’intérieur de la tour." },
      { start: 6.5, label: "GPU", title: "Au plus près du GPU.", text: "La caméra s’approche d’une carte graphique entourée d’un halo d’énergie verte." },
      { start: 10, label: "Fermeture", title: "La tour reprend sa forme.", text: "La caméra revient en vue large et les panneaux se referment autour du châssis." },
    ],
  },
  {
    id: "rack-console",
    src: "/products/rack-console-exploded.mp4",
    poster: "/products/rack-console-carthy.webp",
    name: "Serveur rack avec écran et clavier",
    videoTitle: "Présentation du serveur avec écran et clavier CARTHY",
    storyId: "explorer-console",
    eyebrow: "À l’intérieur du serveur",
    storyTitle: "Du clavier au cœur du serveur.",
    scrollHint: "Faites défiler pour explorer le serveur, de l’ouverture à la fermeture.",
    manualTitle: "Découvrez le serveur en mouvement.",
    description: "Un ordinateur au format rack avec écran intégré et tiroir clavier coulissant, pour accéder directement à la machine.",
    phases: [
      { start: 0, label: "Clavier", title: "Le clavier se déploie.", text: "Le tiroir coulisse vers l’avant tandis que la caméra révèle le serveur sous un nouvel angle." },
      { start: 3, label: "Intérieur", title: "Le châssis révèle son intérieur.", text: "Le capot, le panneau latéral et la façade s’écartent pour dévoiler la carte mère." },
      { start: 5.5, label: "Mémoire", title: "Au cœur de la carte mère.", text: "Un mouvement de caméra met en lumière la mémoire et le refroidissement du processeur." },
      { start: 9.5, label: "Fermeture", title: "Le serveur se referme.", text: "Les panneaux retrouvent leur place, puis le clavier se rétracte dans le châssis." },
    ],
  },
  {
    id: "rack-8-baies",
    src: "/products/rack-8-baies-exploded.mp4",
    poster: "/products/serveur-8-baies-carthy.webp",
    name: "Serveur rack 8 baies CARTHY",
    videoTitle: "Présentation du serveur rack 8 baies CARTHY",
    storyId: "explorer-rack",
    eyebrow: "À l’intérieur du serveur",
    storyTitle: "Chaque composant trouve sa place.",
    scrollHint: "Faites défiler pour explorer le serveur, de l’ouverture à la fermeture.",
    manualTitle: "Découvrez le serveur en mouvement.",
    description: "Un serveur au format rack doté de huit tiroirs de disques en façade, pour réunir calcul et stockage dans un même châssis.",
    phases: [
      { start: 0, label: "Ouverture", title: "Le châssis s’ouvre.", text: "Le capot et les tiroirs se séparent pour révéler la machine." },
      { start: 4, label: "Intérieur", title: "Une vue d’ensemble de l’intérieur.", text: "L’animation révèle l’organisation des composants dans le châssis." },
      { start: 8.5, label: "Stockage", title: "Les huit disques prennent place.", text: "Les tiroirs accueillent les disques avant leur retour en façade." },
      { start: 12.5, label: "Fermeture", title: "Le serveur se referme.", text: "Les éléments retrouvent leur place et la silhouette du serveur se reforme." },
    ],
  },
];

export const productVideoById = Object.fromEntries(productVideos.map((product) => [product.id, product]));
